import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-[#2B4979] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <Logo />
            <p className="text-white/80 mt-4 text-sm">
              Votre partenaire de confiance pour des réservations hôtelières en Tunisie avec les meilleurs tarifs B2B.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Liens rapides</h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="#" className="hover:text-[#FF7B47] transition">À propos</a></li>
              <li><a href="#" className="hover:text-[#FF7B47] transition">Nos services</a></li>
              <li><a href="#" className="hover:text-[#FF7B47] transition">Destinations</a></li>
              <li><a href="#" className="hover:text-[#FF7B47] transition">Conditions générales</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#FF7B47]" />
                <span>+216 75 730 333</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#FF7B47]" />
                <span>sales@gomaxtunisie.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-[#FF7B47] mt-1" />
                <span>97 Rue Salah Ben youssef, Djerba Midoun</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-bold text-lg mb-4">Suivez-nous</h3>
            <div className="flex gap-3">
              <a href="#" className="bg-white/10 hover:bg-[#FF7B47] p-3 rounded-lg transition">
                <Facebook size={20} />
              </a>
              <a href="#" className="bg-white/10 hover:bg-[#FF7B47] p-3 rounded-lg transition">
                <Instagram size={20} />
              </a>
              <a href="#" className="bg-white/10 hover:bg-[#FF7B47] p-3 rounded-lg transition">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 pt-6 text-center text-sm text-white/60">
          © {new Date().getFullYear()} GOMAX Travel & Tourism. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}